import styled from 'styled-components'
import { DropzoneUnstyled } from './unstyled'

export const Dropzone = styled(DropzoneUnstyled)`
  .file-preview {
    width: 100px;
    height: 100px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
  }
  .dropzone-preview {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background: url(${props => (props.input || {}).value}) no-repeat center;
    background-size: cover;
  }

  & > label:nth-child(1) {
    text-align: left;
    color: ${props => props.theme.colors.secondary};
    font-size: ${props => props.theme.fontSizes.form.label};
    font-family: ${props => props.theme.fonts.robotoRegular};
    margin: 0 0 10px 0;
    display: ${props => (props.mainLabel ? 'block' : 'none')};
  }

  & > div:nth-child(2) {
    position: relative;
    width: 100px;
    height: 100px;

    .dropzone {
      position: absolute;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      border: 1px dashed ${props => props.theme.colors.silver};
      border-radius: 3px;
    }

    .dropzoneActive {
      border: 1px solid ${props => props.theme.colors.primary};
    }

    & > div > svg {
      position: absolute;
      width: 14px;
      height: 17px;
      left: 0;
      right: 0;
      top: 30px;
      margin: auto;
      fill: ${props => props.theme.colors.regentGray};
    }

    & > .dropzoneActive ~ svg {
      fill: ${props => props.theme.colors.primary};
      pointer-events: none;
    }

    & > div:nth-child(2) > div {
      text-align: center;
      position: absolute;
      bottom: 27px;
      width: 100%;
      color: ${props => props.theme.colors.regentGray};
      font-family: ${props => props.theme.fonts.robotoRegular};
      font-size: ${props => props.theme.fontSizes.dropZone.dropZoneLabel};
      pointer-events: none;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 5px;
    }

    & > .dropzoneActive ~ div:nth-child(3) {
      color: ${props => props.theme.colors.primary};
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Form/Dropzone/index.js